// Core
import PropTypes from "prop-types";

// Components
import BoxV1 from "components/Atoms/Box/BoxV1";
import Input from "components/Atoms/Input";
import TypographyV1 from "components/Atoms/Typography/TypographyV1";

function FormField({ label, helperText, ...rest }) {
  return (
    <BoxV1 display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
      {/* Label */}
      <BoxV1 mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <TypographyV1 component="label" variant="caption" fontWeight="bold" textTransform="none">
          {label}
        </TypographyV1>
      </BoxV1>

      {/* Input */}
      <Input onWheel={(e) => e.target.blur()} {...rest} />

      {/* Helper Text */}
      {helperText && (
        <BoxV1 mt={0.5} ml={0.5}>
          <TypographyV1 variant="caption" color="textSecondary">
            {helperText}
          </TypographyV1>
        </BoxV1>
      )}
    </BoxV1>
  );
}

// Definindo valores padrão para os props
FormField.defaultProps = {
  label: " ",
  helperText: "", // Por padrão, nenhum texto auxiliar será exibido.
};

// Typechecking dos props
FormField.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string, // Adicionado para validar o helperText
};

export default FormField;
